export const translations = {

};
